import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    success: translate({ id: 'supportTicket.toast.success' }),
    error: translate({ id: 'supportTicket.toast.error' }),
  }))

  return api
}
